import { render, staticRenderFns } from "./AccountFlow.vue?vue&type=template&id=3aa97532&"
import script from "./AccountFlow.vue?vue&type=script&lang=js&"
export * from "./AccountFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports